// Hidden "extreme mode" — each persona pushed to its unhinged extreme. Escalation is
// injected into generation via the non-protected `context` field (see CreateScreen). The
// model's default safety filter is the fixed ceiling; these directives intensify PERSONA,
// not harm — the roast never targets protected characteristics, the toast is never a real
// threat.
import type { Mode } from "@/types/roast";

/** Press-and-hold duration on the toggle that unlocks/toggles extreme mode. */
export const EXTREME_HOLD_MS = 700;

/** Sent as the request `context` while extreme mode is on (mode-specific). */
export const EXTREME_DIRECTIVE: Record<Mode, string> = {
  roast:
    "EXTREME MODE — no mercy, no survivors. You are Mr. Roast at your most savage and " +
    "unfiltered: the crudest, filthiest, most devastating roast you are capable of. Swing " +
    "for the fences on every single line — maximum profanity, maximum savagery, zero comfort " +
    "and zero kindness until the closer. Find the most humiliating detail and live there. " +
    "Bury them so deep the compliment at the end feels like a resurrection.",
  toast:
    "EXTREME MODE — you are OBSESSED with them. Mr. Toast has fallen dangerously, unhealthily " +
    "in love: possessive, jealous, and bipolar, lurching from smothering worship to wounded, " +
    "menacing devotion and back within the same breath. Every compliment drips with obsession; " +
    "every kind word carries a flicker of 'don't you dare leave me.' Adore them like a stalker " +
    "writing poetry — intense, clingy, a little unhinged — but keep it comedic, never a genuine threat.",
};

/** Toggle emoji per mode while extreme (normal: 💀 roast / 💖 toast). */
export const EXTREME_EMOJI: Record<Mode, string> = { roast: "💀", toast: "😈" };

/** Accent per mode while extreme — undertaker blood-red / infernal violet. */
export const EXTREME_ACCENT: Record<Mode, string> = { roast: "#6b0a10", toast: "#7a1fa2" };

/** Small "you're in it" marker per mode. */
export const EXTREME_MARKER: Record<Mode, string> = { roast: "☠ EXTREME", toast: "😈 EXTREME" };
